import { render, staticRenderFns } from "./DrugOrdersInboxRightBar.vue?vue&type=template&id=3cb8e263&"
import script from "./DrugOrdersInboxRightBar.vue?vue&type=script&lang=js&"
export * from "./DrugOrdersInboxRightBar.vue?vue&type=script&lang=js&"
import style0 from "./DrugOrdersInboxRightBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports